import { Injectable } from '@angular/core';

import { segurosStorage } from "./data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";

@Injectable()
export class SeguroService {

  constructor(
    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(segurosStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(segurosStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(segurosStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    // if(Response) {
    //   var otherFormObject: any;
    //
    //   if (otherForm === setoresStorage) {
    //     otherFormObject = this._setorService.getSessionStorage();
    //     otherFormObject.seguro = Response;
    //     this._setorService.setSessionStorage(otherFormObject);
    //   }
    // }
    //
    // this._autocompleteService.clearSessionStorage(segurosStorage);
    //
    // if (otherForm === setoresStorage) {
    //   otherFormObject = this._setorService.getSessionStorage();
    //   if (otherFormObject.id) {
    //     this._setorNavigationService.goToEdit(otherFormObject.id);
    //   } else {
    //     this._setorNavigationService.goToNew();
    //   }
    // }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguros/shared/seguro.service.ts
 **/